import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = { id: String }

  selectVoice() {
    const id = this.idValue
    navigator.clipboard.writeText(id).then(() => {
      const toast = document.getElementById('voice-toast')
      const text = document.getElementById('voice-toast-text')
      if (toast && text) {
        text.textContent = `Voice ID copied — paste it in your persona settings`
        toast.classList.remove('hidden')
        setTimeout(() => toast.classList.add('hidden'), 3000)
      }

      const btn = this.element.querySelector('[data-action*="selectVoice"]')
      if (btn) {
        btn.textContent = 'Copied!'
        btn.classList.remove('btn-primary')
        btn.classList.add('btn-outline')
        setTimeout(() => {
          btn.textContent = 'Select Voice'
          btn.classList.remove('btn-outline')
          btn.classList.add('btn-primary')
        }, 2000)
      }
    })
  }
}
